import React, { useState, useEffect } from 'react';
import './ModalSign.css';
import Signature from '../Signature';

const ModalSign = ({ title = "Tanda Tangan", show, onClose, onChange, signedName1, signedName2 }) => {
    if (!show) return null;

    return (
        <div className="modal-overlay-sign">
            <div className="modal-content-sign">
                <div className="modal-header-sign">
                    <h4 className='text-black'>{title}</h4>
                    <button className="close-button" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="modal-body-sign">
                    <Signature onChangeResult={onChange} signedName1={signedName1} signedName2={signedName2} />
                </div>
            </div>
        </div>
    );
};

export default ModalSign;
